import {
  createPlugin,
  createRoutableExtension,
  createApiFactory,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';
import { gestaoFluxoApiRef, GestaoFluxoClient } from './api';

export const gestaoFluxoPlugin = createPlugin({
  id: 'gestao-fluxo',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: gestaoFluxoApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new GestaoFluxoClient({ discoveryApi, fetchApi }),
    }),
  ],
});

export const GestaoFluxoPage = gestaoFluxoPlugin.provide(
  createRoutableExtension({
    name: 'GestaoFluxoPage',
    component: () =>
      import('./components/GestaoFluxoPage').then(m => m.GestaoFluxoPage),
    mountPoint: rootRouteRef,
  }),
);
